/**
 * Product Tabs Functionality
 * Handles tab navigation and panel switching
 */
class ProductTabs {
  constructor() {
    this.tabsContainer = null;
    this.tabButtons = [];
    this.tabPanels = [];
    this.activeTab = null;
  }

  init() {
    this.tabsContainer = document.querySelector('.product-tabs');
    if (!this.tabsContainer) return;

    // Convert NodeList to Array so we can use .find()
    this.tabButtons = Array.from(this.tabsContainer.querySelectorAll('.product-tab-button'));
    this.tabPanels = Array.from(this.tabsContainer.querySelectorAll('.product-tab-panel'));

    if (this.tabButtons.length === 0 || this.tabPanels.length === 0) return;

    this.setupEventListeners();
    // set open tab to first button that has the class active
    const activeTab = this.tabButtons.find(button => button.classList.contains('active'));
    if (activeTab) {
      this.setActiveTab(activeTab);
    } else {
      this.setActiveTab(this.tabButtons[0]);
    }
  }

  setupEventListeners() {
    this.tabButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        this.handleTabClick(button);
      });

      // Add keyboard support
      button.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.handleTabClick(button);
        }
      });
    });
  }

  handleTabClick(clickedButton) {
    const targetTabId = clickedButton.dataset.tab;
    
    if (!targetTabId) return;

    this.setActiveTab(clickedButton);
    this.showTabPanel(targetTabId);
  }

  setActiveTab(activeButton) {
    // Remove active class from all buttons
    this.tabButtons.forEach(button => {
      button.classList.remove('active');
      button.setAttribute('aria-selected', 'false');
    });

    // Add active class to clicked button
    activeButton.classList.add('active');
    activeButton.setAttribute('aria-selected', 'true');
    
    this.activeTab = activeButton;
  }

  showTabPanel(targetTabId) {
    // Hide all panels
    this.tabPanels.forEach(panel => {
      panel.classList.remove('active');
      panel.setAttribute('aria-hidden', 'true');
    });

    // Show target panel
    const targetPanel = document.getElementById(targetTabId);
    if (targetPanel) {
      targetPanel.classList.add('active');
      targetPanel.setAttribute('aria-hidden', 'false');
    }
  }

  // Method to programmatically switch to a tab
  switchToTab(tabIndex) {
    if (tabIndex >= 0 && tabIndex < this.tabButtons.length) {
      this.handleTabClick(this.tabButtons[tabIndex]);
    }
  }
}

// Initialize tabs when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  const productTabs = new ProductTabs();
  productTabs.init();
});

// Also initialize if DOM is already loaded (for dynamic content)
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    const productTabs = new ProductTabs();
    productTabs.init();
  });
} else {
  const productTabs = new ProductTabs();
  productTabs.init();
}
